import React from 'react';

const CallCentersProblem = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Modern Contact Centers <span className="text-cyan-400">Demand More</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-6 text-center">
          <p className="text-xl text-gray-300 leading-relaxed">
            Today's contact centers operate under constant pressure: higher volume, rising expectations, distributed teams, and tighter quality and compliance standards.
          </p>

          <p className="text-xl text-white font-semibold">
            Agents must handle complex conversations with confidence and consistency — at scale.
          </p>

          <p className="text-lg text-gray-400 italic py-4">
            Legacy LMS platforms and manual coaching can't keep up.
          </p>

          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain delivers the enablement infrastructure modern contact centers need to perform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallCentersProblem;
